import type React from "react";
import type { ValidationError } from "class-validator";
import classes from "../classes.module.scss";
import StepEmailHeader from "./StepEmailHeader";
import StepEmailProAuthBlocks from "./StepEmailProAuthBlocks";
import StepEmailPanelsInner from "./StepEmailPanelsInner";
import type { StepEmailSiteTexts } from "../hooks/useStepEmailSiteTexts";

type Props = {
	siteTexts: StepEmailSiteTexts;
	showIdNotNotaryBlock: boolean;
	onNotaryConnect: () => void;
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	prefilledEmail: string;
};

export default function StepEmailPanelsContent(props: Props): React.JSX.Element {
	const { siteTexts, showIdNotNotaryBlock, onNotaryConnect, onSubmit, validationErrors, prefilledEmail } = props;

	return (
		<div className={classes["root"]}>
			<StepEmailHeader
				welcomeTitle={siteTexts.welcomeTitleDisplay}
				welcomeSubtitle={siteTexts.welcomeSubtitleDisplay}
			/>
			<StepEmailProAuthBlocks
				showIdNotNotaryBlock={showIdNotNotaryBlock}
				notaryTitle={siteTexts.notarySectionTitleDisplay}
				notaryCta={siteTexts.notaryCtaDisplay}
				notarySubscribeCta={siteTexts.notarySubscribeCtaDisplay}
				onNotaryConnect={onNotaryConnect}
			/>
			<StepEmailPanelsInner
				siteTexts={siteTexts}
				onSubmit={onSubmit}
				validationErrors={validationErrors}
				prefilledEmail={prefilledEmail}
			/>
		</div>
	);
}
